module.exports = "<div class=\"col-12 mb-4\">\n  <filtered-list></filtered-list>\n</div>"